import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getData } from './webService/webservice.js';
import { useStore } from './Context/context.jsx';
import './Routes.css';
import { clearStorageKeepEod } from './utils/utils.js';
import MainLayout from './layouts/main-layout.js';
import PosLayout from './layouts/pos-layout.js';
import LoginPage from './pages/Auth/Login/LoginPage.jsx';
import DashboardPage from './pages/Auth/DashBoard/Dashboard.jsx';
import NotFoundPage from './components/Common/NotFoundPage.jsx';
import PasswordReset from '../src/pages/Auth/Reset-Password/reset-password.jsx';
import ForgotPasswordPopup from './components/popup/ForgotPassword.jsx';
import ExpiredSubscriptionScreen from './pages/Auth/Expired/ExpiredSubscriptionScreen.jsx';
import PendingPayments from './pages/Auth/Payments/PendingPayments.jsx';
import PaymentVerifyPage from './pages/Auth/Payment/PaymentVerifyPage.jsx';
import PaymentHistoryPage from './pages/Auth/PaymentHistory/PaymentHistory.jsx';
import SubscriptionHistoryPage from './pages/Auth/SubscriptionHistory/SubscriptionHistory.jsx';
import PosUsageHistoryPage from './pages/Auth/PosUsageHistory/PosUsageHistory.jsx';
import Sidebar from './components/Common/Sidebar.jsx';
import Header from './components/Common/Header.jsx';
import ProductPage from '../src/pages/Auth/Product/productPage.jsx';
import CategoryPage from '../src/pages/Auth/Category/category.jsx';
import SubCategoryPage from '../src/pages/Auth/SubCategory/sub-category.jsx';
import ServicePage from '../src/pages/Auth/Service/service.jsx';
import ServiceCategoryPage from '../src/pages/Auth/ServiceCategory/service-category.jsx';
import ServiceSubCategoryPage from '../src/pages/Auth/ServiceSubCategory/sub-category.jsx';
import CustomerPage from '../src/pages/Auth/Customers/customer.jsx';
import ViewCustomerPage from '../src/pages/Auth/Customers/view-customer.jsx';
import EmployeePage from '../src/pages/Auth/Employee/employee-page.jsx';
import DepartmentPage from '../src/pages/Auth/Department/department-page.jsx';
import DepartmentUserPage from '../src/pages/Auth/Employee/departmentUser-page.jsx';
import StorePage from '../src/pages/Auth/store/store-page.jsx';
import SubscriptionPage from '../src/pages/Auth/subscription/subscription-page.jsx';
import OfferPage from '../src/pages/Auth/offers/offer-page.jsx';
import WalletManagementPage from './pages/Auth/PackageManagement/WalletManagementPage.jsx';
import SettingsPage from '../src/pages/Auth/settings/settings-page.jsx';
import ProfileAndPasswordPage from '../src/pages/Auth/Profile/profileAndPassword.jsx';
import GeneralSettings from './pages/Auth/settings/general-settings.jsx';
import TaxSettings from './pages/Auth/settings/tax-settings.jsx';
import Booking from './pages/Auth/Booking/Booking.jsx';
import BookingCalender from './pages/Auth/Booking/booking-calender.jsx';
import Expense from './pages/Auth/Expense/expense.jsx';
import Report from './pages/Auth/Report/report.jsx';
import PurchasePage from './pages/Auth/Purchase/purchase.jsx';
import CampaignPage from './pages/Auth/Campaign/campaign-page.jsx';
import SendCampaignPage from './pages/Auth/Campaign/sendCampaign-page.jsx';
import CampaignHistoryPage from './pages/Auth/Campaign/campaignHistory.jsx';
import CampaignHistoryViewPage from './pages/Auth/Campaign/CampaignHistoryViewPage.jsx';
import TemplateLibraryPage from './pages/Auth/Campaign/TemplateLibraryPage.jsx';
import CampaignWizard from './pages/Auth/Campaign/CampaignWizard.jsx';
import CampaignAnalyticsView from './pages/Auth/Campaign/CampaignAnalyticsView.jsx';
import MetaConfigPage from './pages/Auth/Campaign/MetaConfigPage.jsx';
import WhatsAppUsagePage from './pages/Auth/Campaign/WhatsAppUsagePage.jsx';
import MessageLogsPage from './pages/Auth/Campaign/MessageLogsPage.jsx';
import ReportPage from './pages/Auth/Report/report-page.jsx';
import EarningReports from './pages/Auth/Report/earning-report.jsx';
import SalesReport from './pages/Auth/Report/sales-report.jsx';
import StaffSalesReport from './pages/Auth/Report/staff-sales-report.jsx';
import AppointmentReport from './pages/Auth/Report/appointment-report.jsx';
import ExpenseReport from './pages/Auth/Report/expense-report.jsx';
import GraphReport from './pages/Auth/Report/graph-report.jsx';
import CustomerReport from './pages/Auth/Report/customer-report.jsx';
import EndOfDayReport from './pages/Auth/Report/eod-report.jsx';
import ProfitLossReport from './pages/Auth/Report/profit-loss-report.jsx';
import PurchaseReport from './pages/Auth/Report/purchase-report.jsx';
import POSPage from './pages/Auth/Pos/pos-page.jsx';
import ReturnPage from './pages/Auth/Return/return-list.jsx';
import ReturnAddPage from './pages/Auth/Return/return-page.jsx';
import SalesPage from './pages/Auth/sales/sales-page.jsx';
import UserPage from './pages/Auth/User/user-page.jsx';
import FranchisePage from './pages/Auth/Franchise/franchise-page.jsx';
import InventoryPage from './pages/Auth/Inventory/inventory-page.jsx';
import SuppliersPage from './pages/Auth/Suppliers/suppliersPage.jsx';
import LoginBackgroundPage from './pages/Auth/Appearance/LoginBackgroundPage.jsx';
import StockImagesPage from './pages/Auth/Appearance/StockImagesPage.jsx';
import LegalDocumentManagement from './pages/Auth/settings/LegalDocuments/LegalDocumentManagement.jsx';
import PublicLegalPage from './pages/Auth/Legal/PublicLegalPage.jsx';
import PackageManagementPage from './pages/Auth/PackageManagement/PackageManagementPage.jsx';


const AppContent = () => {

  const role = localStorage.getItem("role");
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedStoreId } = useStore();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  React.useEffect(() => {
    const role = localStorage.getItem("role");
    const storeIdToCheck = selectedStoreId || localStorage.getItem("currentStoreId");
    const ADMIN_ROLES = ["SuperAdmin", "SelfAdmin", "Accountant", "Manager", "StoreCreator"];

    const isAuthOrReportPage = [
      '/login',
      '/signup',
      '/reset-password',
      '/forgot-password',
      '/privacy-policy',
      '/terms-and-conditions',
      '/reports/eod'
    ].some(path => location.pathname.startsWith(path));

    const todayStr = (() => {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    })();
    const eodCheckedKey = `eodChecked_${storeIdToCheck}_${todayStr}`;

    if (
      role &&
      !ADMIN_ROLES.includes(role) &&
      storeIdToCheck &&
      !isAuthOrReportPage &&
      localStorage.getItem(eodCheckedKey) !== "true"
    ) {
      const checkEODStatus = async () => {
        try {
          const res = await getData("eod/opening-cash-status", { storeId: storeIdToCheck });
          if (res?.data?.isPreviousDayClosed === false) {
            const result = await Swal.fire({
              icon: "warning",
              title: "Previous Day EOD Pending",
              text: "The previous day EOD Closing is still pending. Please complete the EOD process before proceeding with today's activities.",
              showCancelButton: true,
              showDenyButton: true,
              confirmButtonText: "Go to EOD Report",
              denyButtonText: "Proceed Anyway",
              cancelButtonText: "Cancel",
              confirmButtonColor: "#3C0008",
              denyButtonColor: "#64748b",
              cancelButtonColor: "#d33",
              allowOutsideClick: false
            });
            console.log("Opening Cash Response", res.data);

            if (result.isConfirmed) {
              localStorage.setItem(eodCheckedKey, "true");
              navigate("/reports/eod", { state: { pendingEodDate: res?.data?.previousEodDate } });
            } else if (result.isDenied) {
              // "Proceed Anyway" — mark checked and stay on current page
              localStorage.setItem(eodCheckedKey, "true");
            } else {
              // "Cancel" — mark checked and redirect to dashboard (do NOT log out)
              localStorage.setItem(eodCheckedKey, "true");
              navigate("/dashboard");
            }
          } else {
            localStorage.setItem(eodCheckedKey, "true");
          }
        } catch (err) {
          console.error("Error checking EOD status:", err);
        }
      };
      checkEODStatus();
    }
  }, [location.pathname, navigate, selectedStoreId]);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const hideSidebar = [
    '/login',
    '/signup',
    '/reset-password',
    '/forgot-password',
    '/privacy-policy',
    '/terms-and-conditions',
    '/pos',
    '/subscription-expired',
    '/payment-verify'
  ].some(path => {
    if (path === '/pos') {
      return location.pathname === '/pos' || location.pathname.startsWith('/pos/');
    }
    return location.pathname.startsWith(path);
  });

  const hideHeader = [
    '/login',
    '/signup',
    '/reset-password',
    '/forgot-password',
    '/privacy-policy',
    '/terms-and-conditions',
    '/pos',
    '/subscription-expired',
    '/payment-verify'
  ].some(path => {
    if (path === '/pos') {
      return location.pathname === '/pos' || location.pathname.startsWith('/pos/');
    }
    return location.pathname.startsWith(path);
  });

  return (
    <div className="app-container">
      {!hideSidebar && <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />}
      {!hideSidebar && isSidebarOpen && (
        <div className="sidebar-backdrop" onClick={closeSidebar} />
      )}
      <div className="main-area">
        {!hideHeader && <Header onToggleSidebar={toggleSidebar} />}
        <div className={`content-wrapper ${!hideHeader ? 'with-header' : ''}`}>
          <Routes>
            <Route path='/' element={<Navigate to="/login" />} />
            <Route path='/login' element={<LoginPage />} />
            <Route path='/reset-password/:token' element={<PasswordReset />} />
            <Route path='/forgot-password' element={<ForgotPasswordPopup />} />
            <Route path='/privacy-policy' element={<PublicLegalPage docType="PRIVACY_POLICY" />} />
            <Route path='/terms-and-conditions' element={<PublicLegalPage docType="TERMS_AND_CONDITIONS" />} />
            <Route path='/subscription-expired' element={<ExpiredSubscriptionScreen />} />
            <Route path='/payment-verify' element={<PaymentVerifyPage />} />

            <Route element={<PosLayout />}>
              <Route path="/pos" element={<POSPage />} />
            </Route>
            <Route element={<MainLayout />}>

              {(role === "SuperAdmin" || role === "SelfAdmin") && (
                <>
                  <Route path='/dashboard' element={<DashboardPage />} />
                  <Route path='*' element={<NotFoundPage />} />
                  <Route path='/products/*' element={< ProductPage />} />
                  <Route path='/products/category/*' element={<CategoryPage />} />
                  <Route path='/products/sub-category/*' element={<SubCategoryPage />} />
                  <Route path='/services/*' element={<ServicePage />} />
                  <Route path='/services/category/*' element={<ServiceCategoryPage />} />
                  <Route path='/services/sub-category/*' element={<ServiceSubCategoryPage />} />
                  <Route path="/customers/customer/:id/edit" element={<CustomerPage />} />
                  <Route path='/customers/customer/:id' element={<ViewCustomerPage />} />
                  <Route path='/customers/*' element={<CustomerPage />} />
                  <Route path='/stores/*' element={<StorePage />} />
                  <Route path='/employees/*' element={<EmployeePage pageName="Employees" />} />
                  <Route path='/store-admin/*' element={<EmployeePage pageName="StoreAdmin" />} />
                  <Route path='/store-creators/*' element={<UserPage pageName="StoreCreator" />} />
                  <Route path='/users*' element={<UserPage pageName="TVFM-Users" />} />
                  <Route path='/franchisor-admin*' element={<UserPage pageName="FranchisorAdmin" />} />
                  <Route path='/:departmentId/users' element={<DepartmentUserPage />} />
                  <Route path='/membership/*' element={<SubscriptionPage />} />
                  <Route path='/pending-payments' element={<PendingPayments />} />
                  <Route path='/wallets/*' element={<WalletManagementPage />} />
                  <Route path='/reports/wallets/*' element={<WalletManagementPage />} />
                  <Route path='/coupons/*' element={<OfferPage />} />
                  <Route path="/settings/" element={<SettingsPage />}>
                    {/* Default route -> General Settings */}
                    <Route index element={<GeneralSettings />} />
                    <Route path="profile" element={<ProfileAndPasswordPage />} />
                    <Route path="legal-documents" element={<LegalDocumentManagement />} />
                    <Route path="legal-documents/:docType" element={<LegalDocumentManagement />} />
                    {/* Tax tab */}
                    <Route path="tax/*" element={<TaxSettings />} />
                  </Route>
                  <Route path="/appointments/*" element={<Booking />} />
                  <Route path="/appointmentcalender" element={<BookingCalender />} />
                  <Route path="/expense/*" element={<Expense />} />
                  <Route path="/generalsettings/" element={<GeneralSettings />} />
                  <Route path="/purchases/*" element={<PurchasePage />} />
                  <Route path="/suppliers/*" element={<SuppliersPage />} />
                  <Route path="/inventories" element={<InventoryPage />} />
                  <Route path="/campaigns/templates" element={<TemplateLibraryPage />} />
                  <Route path="/campaigns/create" element={<CampaignWizard />} />
                  <Route path="/campaigns/analytics/:id" element={<CampaignAnalyticsView />} />
                  <Route path="/campaigns/meta-config" element={<MetaConfigPage />} />
                  <Route path="/meta-config" element={<MetaConfigPage />} />
                  <Route path="/campaigns/whatsapp-usage" element={<WhatsAppUsagePage />} />
                  <Route path="/whatsapp-usage" element={<WhatsAppUsagePage />} />
                  <Route path="/campaigns/message-logs" element={<MessageLogsPage />} />
                  <Route path="/campaign/message-logs" element={<MessageLogsPage />} />
                  <Route path="/campaigns/*" element={<CampaignPage />} />
                  <Route path="/sendcampaigns/:campaignId" element={<SendCampaignPage />} />
                  <Route path="/campaign/history" element={<CampaignHistoryPage />} />
                  <Route path="/campaign/history/view" element={<CampaignHistoryViewPage />} />
                  <Route path="/franchisor/*" element={<FranchisePage />} />
                  <Route path="/reports/sales" element={<SalesReport />} />
                  <Route path="/reports/staff-sales" element={<StaffSalesReport />} />
                  <Route path="/reports/appointment" element={<AppointmentReport />} />
                  <Route path="/reports/expense" element={<ExpenseReport />} />
                  <Route path="/reports/profit-loss" element={<ProfitLossReport />} />
                  <Route path="/reports/purchase" element={<PurchaseReport />} />
                  <Route path="/reports" element={<Report />}>
                    <Route index element={<Navigate to="summary" />} />
                    <Route path="summary" element={<ReportPage />} />
                    <Route path="earning" element={<EarningReports />} />
                    <Route path="graph" element={<GraphReport />} />
                    <Route path="customer" element={<CustomerReport />} />
                    <Route path="eod" element={<EndOfDayReport />} />
                  </Route>
                  <Route path="/return" element={<ReturnPage />} />
                  <Route path="/return/add" element={<ReturnAddPage />} />
                  <Route path="/sales/*" element={<SalesPage />} />
                  <Route path="/appearance/background" element={<LoginBackgroundPage />} />
                  <Route path="/appearance/stock-images" element={<StockImagesPage />} />
                  <Route path="/package-management/*" element={<PackageManagementPage />} />
                  <Route path="/payment-history" element={<PaymentHistoryPage />} />
                  <Route path="/subscription-history" element={<SubscriptionHistoryPage />} />
                  <Route path="/pos-usage-history" element={<PosUsageHistoryPage />} />
                  <Route path="/pos_usage_history" element={<PosUsageHistoryPage />} />

                </>
              )}

              {(role === "FranchiseAdmin" || role === "StoreAdmin") && (
                <>
                  <Route path='/dashboard' element={<DashboardPage />} />
                  <Route path='*' element={<NotFoundPage />} />
                  <Route path='/products/*' element={< ProductPage />} />
                  <Route path='/products/category/*' element={<CategoryPage />} />
                  <Route path='/products/sub-category/*' element={<SubCategoryPage />} />
                  <Route path='/services/*' element={<ServicePage />} />
                  <Route path='/services/category/*' element={<ServiceCategoryPage />} />
                  <Route path='/services/sub-category/*' element={<ServiceSubCategoryPage />} />
                  <Route path="/customers/customer/:id/edit" element={<CustomerPage />} />
                  <Route path='/customers/customer/:id' element={<ViewCustomerPage />} />
                  <Route path='/customers/*' element={<CustomerPage />} />
                  <Route path='/departments/*' element={<DepartmentPage />} />
                  <Route path='/employees/*' element={<EmployeePage />} />
                  <Route path='/users*' element={<UserPage />} />
                  <Route path='/:departmentId/users' element={<DepartmentUserPage />} />
                  <Route path='/membership/*' element={<SubscriptionPage />} />
                  <Route path='/wallets/*' element={<WalletManagementPage />} />
                  <Route path='/reports/wallets/*' element={<WalletManagementPage />} />
                  <Route path='/coupons/*' element={<OfferPage />} />
                  <Route path="/settings/" element={<SettingsPage />}>
                    {/* Default route -> General Settings */}
                    <Route index element={<GeneralSettings />} />
                    <Route path="profile" element={<ProfileAndPasswordPage />} />
                    {/* Tax tab */}
                    <Route path="tax/*" element={<TaxSettings />} />
                  </Route>
                  <Route path="/appointments/*" element={<Booking />} />
                  <Route path="/appointmentcalender" element={<BookingCalender />} />
                  <Route path="/expense/*" element={<Expense />} />
                  <Route path="/generalsettings/" element={<GeneralSettings />} />
                  <Route path="/purchases/*" element={<PurchasePage />} />
                  <Route path="/suppliers/*" element={<SuppliersPage />} />
                  <Route path="/inventories" element={<InventoryPage />} />
                  <Route path="/campaigns/templates" element={<TemplateLibraryPage />} />
                  <Route path="/campaigns/create" element={<CampaignWizard />} />
                  <Route path="/campaigns/analytics/:id" element={<CampaignAnalyticsView />} />
                  <Route path="/campaigns/meta-config" element={<MetaConfigPage />} />
                  <Route path="/meta-config" element={<MetaConfigPage />} />
                  <Route path="/campaigns/message-logs" element={<MessageLogsPage />} />
                  <Route path="/campaign/message-logs" element={<MessageLogsPage />} />
                  <Route path="/campaigns/*" element={<CampaignPage />} />
                  <Route path="/sendcampaigns/:campaignId" element={<SendCampaignPage />} />
                  <Route path="/campaign/history" element={<CampaignHistoryPage />} />
                  <Route path="/campaign/history/view" element={<CampaignHistoryViewPage />} />
                  <Route path="/franchisor/*" element={<FranchisePage />} />
                  <Route path="/reports/sales" element={<SalesReport />} />
                  <Route path="/reports/staff-sales" element={<StaffSalesReport />} />
                  <Route path="/reports/appointment" element={<AppointmentReport />} />
                  <Route path="/reports/expense" element={<ExpenseReport />} />
                  <Route path="/reports/profit-loss" element={<ProfitLossReport />} />
                  <Route path="/reports/purchase" element={<PurchaseReport />} />
                  <Route path="/reports" element={<Report />}>
                    <Route index element={<Navigate to="summary" />} />
                    <Route path="summary" element={<ReportPage />} />
                    <Route path="earning" element={<EarningReports />} />
                    <Route path="graph" element={<GraphReport />} />
                    <Route path="customer" element={<CustomerReport />} />
                    <Route path="eod" element={<EndOfDayReport />} />
                  </Route>
                  <Route path="/return" element={<ReturnPage />} />
                  <Route path="/return/add" element={<ReturnAddPage />} />
                  <Route path="/sales/*" element={<SalesPage />} />
                </>
              )}
              {
                role === "StoreCreator" && (
                  <>
                    <Route path='/stores/*' element={<StorePage />} />
                    <Route path='/store-admin/*' element={<EmployeePage pageName="StoreAdmin" />} />
                  </>
                )
              }

              {(role === "ClusterManager" || role === "StoreManager" || role === "Manager") && (
                <>
                  <Route path='/dashboard' element={<DashboardPage />} />
                  <Route path='*' element={<NotFoundPage />} />
                  <Route path='/products/*' element={< ProductPage />} />
                  <Route path='/products/category/*' element={<CategoryPage />} />
                  <Route path='/products/sub-category/*' element={<SubCategoryPage />} />
                  <Route path='/services/*' element={<ServicePage />} />
                  <Route path='/services/category/*' element={<ServiceCategoryPage />} />
                  <Route path='/services/sub-category/*' element={<ServiceSubCategoryPage />} />
                  <Route path="/customers/customer/:id/edit" element={<CustomerPage />} />
                  <Route path='/customers/customer/:id' element={<ViewCustomerPage />} />
                  <Route path='/customers/*' element={<CustomerPage />} />
                  <Route path='/departments/*' element={<DepartmentPage />} />
                  {role !== "Manager" && <Route path='/employees/*' element={<EmployeePage />} />}
                  <Route path='/:departmentId/users' element={<DepartmentUserPage />} />
                  <Route path='/membership/*' element={<SubscriptionPage />} />
                  <Route path='/wallets/*' element={<WalletManagementPage />} />
                  <Route path='/reports/wallets/*' element={<WalletManagementPage />} />
                  <Route path='/coupons/*' element={<OfferPage />} />
                  <Route path="/settings/" element={<SettingsPage />}>
                    {/* Default route -> General Settings */}
                    <Route index element={<GeneralSettings />} />
                    <Route path="profile" element={<ProfileAndPasswordPage />} />
                    {/* Tax tab */}
                    <Route path="tax/*" element={<TaxSettings />} />
                  </Route>
                  <Route path="/appointments/*" element={<Booking />} />
                  <Route path="/appointmentcalender" element={<BookingCalender />} />
                  <Route path="/expense/*" element={<Expense />} />
                  <Route path="/generalsettings/" element={<GeneralSettings />} />
                  <Route path="/purchases/*" element={<PurchasePage />} />
                  <Route path="/suppliers/*" element={<SuppliersPage />} />
                  <Route path="/inventories" element={<InventoryPage />} />
                  <Route path="/campaigns/templates" element={<TemplateLibraryPage />} />
                  <Route path="/campaigns/create" element={<CampaignWizard />} />
                  <Route path="/campaigns/analytics/:id" element={<CampaignAnalyticsView />} />
                  <Route path="/campaigns/meta-config" element={<MetaConfigPage />} />
                  <Route path="/meta-config" element={<MetaConfigPage />} />
                  <Route path="/campaigns/message-logs" element={<MessageLogsPage />} />
                  <Route path="/campaign/message-logs" element={<MessageLogsPage />} />
                  <Route path="/campaigns/*" element={<CampaignPage />} />
                  <Route path="/sendcampaigns/:campaignId" element={<SendCampaignPage />} />
                  <Route path="/campaign/history" element={<CampaignHistoryPage />} />
                  <Route path="/campaign/history/view" element={<CampaignHistoryViewPage />} />
                  <Route path="/reports/sales" element={<SalesReport />} />
                  <Route path="/reports/staff-sales" element={<StaffSalesReport />} />
                  <Route path="/reports/appointment" element={<AppointmentReport />} />
                  <Route path="/reports/expense" element={<ExpenseReport />} />
                  <Route path="/reports/profit-loss" element={<ProfitLossReport />} />
                  <Route path="/reports/purchase" element={<PurchaseReport />} />
                  <Route path="/reports" element={<Report />}>
                    <Route index element={<Navigate to="summary" />} />
                    <Route path="summary" element={<ReportPage />} />
                    <Route path="earning" element={<EarningReports />} />
                    <Route path="graph" element={<GraphReport />} />
                    <Route path="customer" element={<CustomerReport />} />
                    <Route path="eod" element={<EndOfDayReport />} />
                  </Route>
                  <Route path="/return" element={<ReturnPage />} />
                  <Route path="/return/add" element={<ReturnAddPage />} />
                  <Route path="/sales/*" element={<SalesPage />} />
                </>
              )}

              {role === "Biller" && (
                <>
                  <Route path="/appointments/*" element={<Booking />} />
                  <Route path="/appointmentcalender" element={<BookingCalender />} />
                  <Route path="/expense/*" element={<Expense />} />
                  <Route path="/purchases/*" element={<PurchasePage />} />
                  <Route path="/suppliers/*" element={<SuppliersPage />} />
                  <Route path="/inventories" element={<InventoryPage />} />
                  <Route path="/return" element={<ReturnPage />} />
                  <Route path="/return/add" element={<ReturnAddPage />} />
                  <Route path="/sales/*" element={<SalesPage />} />
                  <Route path="/wallets/*" element={<WalletManagementPage />} />
                  <Route path="/reports/wallets/*" element={<WalletManagementPage />} />
                </>
              )}

              {role === "Accountant" && (
                <>
                  <Route path="/sales/*" element={<SalesPage />} />
                  <Route path="/purchases/*" element={<PurchasePage />} />
                  <Route path="/expense/*" element={<Expense />} />
                  <Route path="/reports/sales" element={<SalesReport />} />
                  <Route path="/reports/staff-sales" element={<StaffSalesReport />} />
                  <Route path="/reports/appointment" element={<AppointmentReport />} />
                  <Route path="/reports/expense" element={<ExpenseReport />} />
                  <Route path="/reports/profit-loss" element={<ProfitLossReport />} />
                  <Route path="/reports/purchase" element={<PurchaseReport />} />
                  <Route path="/reports/wallets/*" element={<WalletManagementPage />} />
                  <Route path="/reports" element={<Report />}>
                    <Route index element={<Navigate to="summary" />} />
                    <Route path="summary" element={<ReportPage />} />
                    <Route path="earning" element={<EarningReports />} />
                    <Route path="graph" element={<GraphReport />} />
                    <Route path="customer" element={<CustomerReport />} />
                    <Route path="eod" element={<EndOfDayReport />} />
                  </Route>
                </>
              )}

            </Route>

            {/* 🔒 Redirect if Not Authenticated */}
            {!role && <Route path="*" element={<Navigate to="/login" replace />} />}

          </Routes >
        </div >
      </div >
    </div >
  );
};


const AppRoutes = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};


export default AppRoutes;